import React from 'react'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className='glass-card rounded-t-3xl mt-16 p-8'>
      <div className='max-w-6xl mx-auto'>
        {/* Main Footer Content */}
        <div className='grid grid-cols-1 md:grid-cols-4 gap-8 mb-8'>
          {/* Brand Section */}
          <div className='md:col-span-2'>
            <div className='flex items-center space-x-3 mb-4'>
              <div className='w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl flex items-center justify-center shadow-lg'>
                <span className='text-white font-bold text-xl'>BAi</span>
              </div>
              <div>
                <h3 className='text-xl font-bold text-white'>TheBoomer</h3>
                <p className='text-white/70 text-sm'>AI Directory</p>
              </div>
            </div>
            <p className='text-white/60 text-sm leading-relaxed mb-4'>
              Discover the power of AI.
            </p>
            <div className='flex items-center space-x-4'>
              <div className='flex items-center space-x-2 text-white/60 text-sm'>
                <div className='w-2 h-2 bg-green-500 rounded-full animate-pulse'></div>
                <span>Always Updated</span>
              </div>
              <div className='flex items-center space-x-2 text-white/60 text-sm'>
                <div className='w-2 h-2 bg-blue-500 rounded-full animate-pulse'></div>
                <span>Curiousity Driven</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className='text-white font-semibold mb-4'>Quick Links</h4>
            <ul className='space-y-2'>
              <li>
                <a
                  href='/tools'
                  className='text-white/60 hover:text-white transition-colors text-sm'
                >
                  AI Tools
                </a>
              </li>
              <li>
                <a
                  href='/companies'
                  className='text-white/60 hover:text-white transition-colors text-sm'
                >
                  AI Companies
                </a>
              </li>
              <li>
                <a
                  href='/agents'
                  className='text-white/60 hover:text-white transition-colors text-sm'
                >
                  AI Agents
                </a>
              </li>
              <li>
                <a
                  href='/timeline'
                  className='text-white/60 hover:text-white transition-colors text-sm'
                >
                  AI Timeline
                </a>
              </li>
            </ul>
          </div>

          {/* External Links */}
          <div>
            <h4 className='text-white font-semibold mb-4'>Contact</h4>
            <ul className='space-y-2'>
              <li>
                <a
                  href='https://blog.theboomer.ai'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-white/60 hover:text-white transition-colors text-sm flex items-center space-x-2'
                >
                  <svg
                    className='w-4 h-4'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth={2}
                      d='M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z'
                    />
                  </svg>
                  <span>Blog</span>
                  <svg
                    className='w-3 h-3'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth={2}
                      d='M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14'
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href='https://in.linkedin.com/in/ucbrijesh'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-white/60 hover:text-white transition-colors text-sm flex items-center space-x-2'
                >
                  <svg
                    className='w-4 h-4'
                    fill='currentColor'
                    viewBox='0 0 24 24'
                  >
                    <path d='M20.447 20.452h-3.554v-5.569c0-1.328-.024-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.349V9h3.414v1.561h.049c.476-.9 1.637-1.852 3.368-1.852 3.602 0 4.268 2.372 4.268 5.456v6.287zM5.337 7.433a2.07 2.07 0 1 1 0-4.141 2.07 2.07 0 0 1 0 4.141zm1.777 13.019H3.56V9h3.554v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.225 0z' />
                  </svg>
                  <span>LinkedIN</span>
                  <svg
                    className='w-3 h-3'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth={2}
                      d='M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14'
                    />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className='border-t border-white/10 pt-6'>
          <div className='flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0'>
            {/* Copyright */}
            <div className='text-center md:text-left'>
              <p className='text-white/60 text-sm'>
                {currentYear} TheBoomer AI Directory. All rights reserved.
              </p>
            </div>

            {/* Credits */}
            <div className='flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6 text-sm'>
              <div className='flex items-center space-x-2 text-white/60'>
                <span>Built with</span>
                <a
                  href='https://windsurf.ai'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-blue-400 hover:text-blue-300 transition-colors font-medium'
                >
                  Windsurf AI
                </a>
              </div>
              <div className='flex items-center space-x-2 text-white/60'>
                <span>Developed by</span>
                <a
                  href='https://in.linkedin.com/in/ucbrijesh'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-purple-400 hover:text-purple-300 transition-colors font-medium flex items-center space-x-1'
                >
                  <span>ucbrijesh</span>
                  <svg
                    className='w-3 h-3'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth={2}
                      d='M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14'
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Info */}
        <div className='mt-4 text-center'>
          <p className='text-white/40 text-xs'>
            This information is maintained and updated regularly with the latest
            AI tools and resources.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
